import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	SENT_BY_EMAIL: '[data-fragment="OrderBillingInfo.sentByEmail"]',
	ADD_MAIL: '[data-fragment="OrderBillingInfo.addMail"]',
	AGREED: '[data-fragment="OrderBillingInfo.agreed"]',

};

class OrderBillingInfo extends WebComponent {
	constructor(props) {
		super(props);
		const {
		} = props;
	}

	didMount() {

		this.on('change', fragments.AGREED, this.handleChangeAgreed);
	}

	handleChangeAgreed = (e) => {
		if(e.target.checked) {
			setTimeout(() => {
				this.element.querySelector(fragments.ADD_MAIL).click();
			},500);
			$(fragments.SENT_BY_EMAIL).val('true').trigger('change');
		} else {
			$(fragments.SENT_BY_EMAIL).val('false').trigger('change');
		}
	}
}

export default OrderBillingInfo;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Orders/OrderBillingInfo.js